module.exports = __webpack_public_path__ + "static/media/staffnum.db823eec.svg";